export default {"src":"/_next/static/media/pause.51eb1abf.svg","height":15,"width":9,"blurWidth":0,"blurHeight":0};